import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../service/auth.service';
import { TOKEN } from '../keys/keys';
import { firstValueFrom } from 'rxjs';
import { SistemaContextService } from '../service/sistema-context.service';
import { PermisosStateService } from '../service/permisos-state.service';

export const authGuard: CanActivateFn = async (route, state) => {
  //? Inyección de dependencias
  const auth = inject(AuthService);
  const cookies = inject(CookieService);
  const sistemaContext = inject(SistemaContextService);
  const permisosState = inject(PermisosStateService);
  //* Obtenemos el token
  const token = cookies.get(TOKEN);
  //! Si no existe
  if (!token) return restrict(auth);
  //? Verificamos el token con la API y procedemos en función de la respuesta
  const isValidToken = await validateToken(auth, token);
  if (!isValidToken) return restrict(auth);

  // Si el usuario ya tiene un sistema seleccionado en storage, asegurarnos de cargar permisos
  try {
    if (sistemaContext.tieneSistemaSeleccionado()) {
      const codigo = sistemaContext.sistemaActual as any;
      if (permisosState.sistemaCodigoActual !== codigo) {
        await firstValueFrom(
          permisosState.cargarPermisos(codigo, sistemaContext.empresaActual ?? undefined),
        );
      }
    }
  } catch (err) {
    console.warn('No se pudieron cargar permisos en authGuard:', err);
  }

  return true;
};

/** @description Valida el token llamando al servicio de autenticación. */
const validateToken = async (auth: AuthService, token: string) => {
  try {
    //? Consultamos a nuestra API Rest
    return await firstValueFrom(auth.checkToken(token));
  } catch {
    //! En caso de error, consideramos el token como inválido
    return false;
  }
};

/** @description Pasamos el servicio, deslogeamos y retornamos false para detener la propagación de la ruta */
const restrict = (auth: AuthService) => {
  auth.logout();
  return false;
};
